import { validate, type Result } from '../errors/errors';
import type { Deps } from '../interfaces/stores';
import { BackupSchema, type Backup } from '../schemas/entities';

type D<K extends keyof Deps> = Pick<Deps, K>;

export const exportBackup = (d: D<'backup' | 'clock'>) => async (): Promise<Backup> => ({
  app: 'flow',
  backupVersion: 1,
  exportedAt: d.clock.now(),
  ...(await d.backup.exportAll()),
});

/** Validates the entire file first and reports every problem; nothing is written unless all of it is valid. */
export const importBackup = (d: D<'backup'>) => async (json: unknown): Promise<Result<Backup>> => {
  const v = validate(BackupSchema, json);
  if (!v.ok) return v;
  await d.backup.importAll(v.value);
  return v;
};
